// react
import React, { useEffect, useState } from "react";
// npm
import axios from 'axios';
// internal
import Header from "./../header/Header"
import Tuto from "./../tuto/Tuto"
import Menu from "./../menu/Menu"
import Circuit from "./../circuit/Circuit"
import CircuitCenter from "./../circuit/CircuitCenter"
import Popup from "./../popup/Popup"
// internal
import GetTrad from "./../utils/GetTrad"
// style
import "./Main.css"

const Leap = require("leapjs")

const Main = () => {

	const eventMode = false;

	const requestRef = React.useRef();

	const [step, setStep] = useState(0)

	const [position] = useState({ x: 0, y: 0, oldx: 0, oldy: 0 })

	const [tiime] = useState({ current: Date.now(), previous: 0, sleep: false, timeToSleep:90000 })

	const [lang, setLang] = useState("fr")
	const [popup, setPopup] = useState(null)
	const [menuDisplay, setMenuDisplay] = useState(false)
	const [menu, setMenu] = useState(null)
	const [content, setContent] = useState(null)

	const [plantsFinal, setPlantsFinal] = useState([])

	const [restart, setRestart] = useState(0.1)

	let toggleMenu = () => {
		if(popup !== null){
			setPopup(null)
			var myVideo = document.getElementById('videoPlayer');
			if(myVideo !== null){
				myVideo.pause();
			}
		}else{
			setMenuDisplay(!menuDisplay)
		}		
	}

	let togglePopup = (id) => {
		setMenuDisplay(false)
		setPopup(id)
		if(id === null){
			tiime.timeToSleep = 90000
		}else{
			tiime.timeToSleep = 150000
		}
	}

	let toggle = (id) => {
		//console.log("toggle "+id)
		if (id === menu) {
			setMenu(null);
		} else {
			setMenu(id);
		}
	}

	useEffect(() => {

		let circuitContainer = document.getElementById("circuit-container");

		if(menu === "top"){
			circuitContainer.style.transform = "translateX(0%) translateY(35%)";
		}else if(menu === "left"){
			circuitContainer.style.transform = "translateX(40%) translateY(0%)";
		}else if(menu === "right"){
			circuitContainer.style.transform = "translateX(-40%) translateY(0%)";
		}else if(menu === "bottom"){
			circuitContainer.style.transform = "translateX(0%) translateY(-35%)";
		}else{
			circuitContainer.style.transform = "translateX(0%) translateY(0%)";
		}
		
	}, [menu])

	// load files
	useEffect(() => {
		axios.get("./data/products.json")
			.then(res => {
				setContent(res.data)
			})
			.catch(err => console.log(err))
	}, [])

	// parralax effect

	const animate = time => {
		//console.log(time)

		if(position.oldx == position.x && position.oldy == position.y){

		}else{
			if(tiime.sleep){
				if(eventMode){
					setRestart(Math.random(12))
				}
			}
			tiime.sleep = false;
			tiime.current = Date.now();
		}

		if(eventMode){
			if((Number(Date.now()) - Number(tiime.current)) > tiime.timeToSleep && tiime.sleep === false){
				tiime.sleep = true
				setMenu(null)
				setMenuDisplay(false)
				setPopup(null)
				setStep(0)
			}
		}

		position.oldx = position.x
		position.oldy = position.y

		//console.log(position.oldx - position.x)

		for (let p of plantsFinal) {
			//p.dom.style.left = ((position.x*p.coeff)-5)+"%";
			//p.dom.style.top = ((position.y*p.coeff)-5)+"%";
			p.dom.style.transform = "translateX(" + ((position.x * p.coeff) - 5) + "%" + ") translateY(" + ((position.y * p.coeff) - 5) + "%" + ")";
		}

		requestRef.current = requestAnimationFrame(animate);
	}

	useEffect(() => {

		console.log("start")

		let domLeap = document.getElementById("cursor")

		const setFromEvent = (e) => {
			let coeff = 1;
			let x = ((e.clientX / window.innerWidth) - 0.5) * coeff;
			let y = ((e.clientY / window.innerHeight) - 0.5) * coeff;

			position.x = x;
			position.y = y;

			domLeap.style.left = e.clientX+"px";
			domLeap.style.top = e.clientY+"px";
		};

		let plants = ["plant0", "plant2", "plant4"/*, "plant6"*/]
		let plantsFinalTemp = []

		for (let p of plants) {
			let dom = document.getElementById(p)
			plantsFinal.push({
				name: p,
				dom: dom,
				coeff: Number(dom.dataset.coeff)
			})
		}

		setPlantsFinal(plantsFinalTemp)

		window.addEventListener("mousemove", setFromEvent);
		requestRef.current = requestAnimationFrame(animate);

		/*let stateGrab = 0;

		Leap.loop({ enableGestures: true }, function (frame) {
			//console.log(frame)
			//console.log(frame.hands.length);
			if(frame.hands.length > 0){
				//console.log(frame.hands[0].palmPosition[2])

				let positionX = 50;
				let positionY = 50;

				positionY = ((frame.hands[0].palmPosition[1]-400)/-2)+10;
				positionX = frame.hands[0].palmPosition[0]/2

				//console.log(frame.hands[0].grabStrength)

				if(frame.hands[0].grabStrength == 1){
					if(stateGrab == 0){
						stateGrab = 1;
						console.log("CLICK")
					}
				}else if(frame.hands[0].grabStrength == 0){
					if(stateGrab == 1){
						stateGrab = 0;
						console.log("RELEASE")
					}
				}

				domLeap.style.left = (positionX)+"%";
				domLeap.style.top = (positionY)+"%";

			}else{

			}
		});*/

		/*var controller = Leap.loop({ enableGestures: true }, function (frame) {
			if (frame.valid && frame.gestures && frame.gestures.length > 0) {
				console.log("ok")
				frame.gestures.forEach(function (gesture) {
					switch (gesture.type) {
						case "circle":
							console.log("Circle Gesture");
							break;
						case "keyTap":
							console.log("Key Tap Gesture");
							break;
						case "screenTap":
							console.log("Screen Tap Gesture");
							break;
						case "swipe":
							console.log("Swipe Gesture");
							break;
					}
				});
			}
		});*/

		/*var controller = new Leap.Controller()
		console.log(controller)
		controller.on("frame", function(frame) {
			console.log("Frame: " + frame.id + " @ " + frame.timestamp);
		});*/

		return () => {
			console.log("cancel")
			window.removeEventListener("mousemove", setFromEvent);
			cancelAnimationFrame(requestRef.current);
		};
	}, []);

	return (
		<React.Fragment>
			<div className="landscape-mobile">
				<div className="landscape-mobile-icon"></div>
			</div>
			<div
				id="cursor"
				className="cursor"
			>
				{/*<div className="icon"></div>*/}
			</div>
			<Tuto lang={lang} restart={restart} />
			<Popup
				popup={popup}
				setPopup={setPopup}
				lang={lang}
				content={content}
			/>
			<Header
				lang={lang}
				setLang={setLang}
				toggleMenu={toggleMenu}
				menuDisplay={menuDisplay}
				popup={popup}
				setPopup={setPopup}
			/>
			<Menu
				menuDisplay={menuDisplay}
				lang={lang}
				menu={menu}
				content={content}
				toggleMenu={toggleMenu}
				toggle={toggle}
				togglePopup={togglePopup}
			/>

			<div id="plant0" data-coeff="6" className="plant plant-00-sd"></div>
			<div id="plant2" data-coeff="4" className="plant plant-02-sd"></div>
			<div id="plant4" data-coeff="2" className="plant plant-04-sd"></div>

			<div
				className={"logo-container "+(step === 1 ? "logo-container-slide" : "")}
				style={{
					//opacity: step === 0 ? 1 : 0,
					pointerEvents: step === 0 ? "auto" : "none"
				}}
			>
				<p className="tsv5 main">TECH<span>4</span>PLANET</p>
				<p className="tsv5 intro"><GetTrad id="homeintro" lang={lang} /></p>
				<div
					className="btn tsv7"
					onClick={() => setStep(1)}
				><GetTrad id="btnstart" lang={lang} /></div>
			</div>

			<div
				id={"circuit-container"}
				className={"circuit-container "+(step === 1 ? "circuit-container-slide" : "")}
				style={{
					//opacity: step === 1 ? 1 : 0,
					pointerEvents: step === 1 ? "auto" : "none"
				}}
			>
				<Circuit
					id={"top"}
					menu={menu}
					toggle={toggle}
					popup={togglePopup}
					content={content}
					lang={lang}
				/>
				<Circuit
					id={"left"}
					menu={menu}
					toggle={toggle}
					popup={togglePopup}
					content={content}
					lang={lang}
				/>
				<Circuit
					id={"right"}
					menu={menu}
					toggle={toggle}
					popup={togglePopup}
					content={content}
					lang={lang}
				/>
				<Circuit
					id={"bottom"}
					menu={menu}
					toggle={toggle}
					popup={togglePopup}
					content={content}
					lang={lang}
				/>
				<CircuitCenter
					id={"center"}
					menu={menu}
					toggle={toggle}
					popup={togglePopup}
					content={content}
					lang={lang}
				/>
			</div>
			{/*<div id="plant6" data-coeff="-1" className="plant plant-06"></div>*/}
		</React.Fragment>
	)
}

export default Main;